import { render } from "./ChaptersFilter.vue?vue&type=template&id=545de506"
import script from "./ChaptersFilter.vue?vue&type=script&lang=js"
export * from "./ChaptersFilter.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__